import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FC, useState } from 'react';
import { useQuery } from 'react-query';
import Modal from '..';
import Button from '@/components/button';
import Select from '@/components/form/select';
import useModal from '@/hooks/use-modal.hook';
import useApp from '@/hooks/use-app.hook';
import { QueryKey } from '@/lib/query-client';
import {
  PublicCatalogDownloadFormat,
  PublicCatalogDownloadOpts,
  downloadCatalog,
} from '@/lib/services/public-service.service';

const CatalogExportModal: FC = () => {
  const { closeModal } = useModal();
  const { user } = useApp();
  const [format, setFormat] = useState<PublicCatalogDownloadFormat | ''>('');

  const { refetch, isFetching } = useQuery(
    [QueryKey.PublicServicesDownload, format],
    () => downloadCatalog(format as PublicCatalogDownloadFormat, user?.orgId),
    { enabled: false }
  );

  const canExport = !!format && !isFetching;

  const handleChangeFormat = (value?: string) => {
    setFormat((value || '') as PublicCatalogDownloadFormat | '');
  };

  const handleExport = () => {
    void refetch().then(({ isSuccess }) => {
      if (!isSuccess) {
        return;
      }

      closeModal();
    });
  };

  return (
    <Modal>
      <DialogTitle>Export Public Services Catalog</DialogTitle>
      <DialogContent>
        <Select
          label="Export Format"
          name="export-format"
          value={format}
          options={PublicCatalogDownloadOpts}
          onChange={handleChangeFormat}
        />
      </DialogContent>
      <DialogActions>
        <Button label="Cancel" type="cancel" onClick={closeModal} />
        <Button label="Export" disabled={!canExport} loading={isFetching} onClick={handleExport} />
      </DialogActions>
    </Modal>
  );
};

export default CatalogExportModal;
